import { memo } from "react";

function WINGDeliveryStopMarker({
  stopNo,
  backgroundColor,
  borderColor,
  textColor,
}) {
  const shiftLeft = stopNo && stopNo < 10 ? 0 : -2;
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1" fill={borderColor}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29 7.5C29 11.0899 26.0898 14 22.5 14C18.9102 14 16 11.0899 16 7.5C16 3.91015 18.9102 1 22.5 1C26.0898 1 29 3.91015 29 7.5ZM21.4995 15.2875C17.8642 15.0414 14.9586 12.1358 14.7125 8.50055C13.7 8.17551 12.6205 8 11.5 8C5.70101 8 1 12.701 1 18.5C1 24.299 5.70101 29 11.5 29C17.299 29 22 24.299 22 18.5C22 17.3795 21.8245 16.3 21.4995 15.2875Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 7.5C29 11.0899 26.0898 14 22.5 14C18.9102 14 16 11.0899 16 7.5C16 3.91015 18.9102 1 22.5 1C26.0898 1 29 3.91015 29 7.5ZM21.4995 15.2875C17.8642 15.0414 14.9586 12.1358 14.7125 8.50055C13.7 8.17551 12.6205 8 11.5 8C5.70101 8 1 12.701 1 18.5C1 24.299 5.70101 29 11.5 29C17.299 29 22 24.299 22 18.5C22 17.3795 21.8245 16.3 21.4995 15.2875Z"
        fill={backgroundColor}
      />
      <path
        d="M14.7125 8.50055L15.7102 8.43301L15.6644 7.75586L15.0182 7.54841L14.7125 8.50055ZM21.4995 15.2875L22.4517 14.9819L22.2442 14.3356L21.567 14.2898L21.4995 15.2875ZM22.5 15C26.6421 15 30 11.6421 30 7.5H28C28 10.5376 25.5376 13 22.5 13V15ZM15 7.5C15 11.6421 18.3579 15 22.5 15V13C19.4624 13 17 10.5376 17 7.5H15ZM22.5 0C18.3579 0 15 3.35786 15 7.5H17C17 4.46243 19.4624 2 22.5 2V0ZM30 7.5C30 3.35786 26.6421 0 22.5 0V2C25.5376 2 28 4.46243 28 7.5H30ZM13.7148 8.56809C13.9947 12.7024 17.2976 16.0053 21.432 16.2852L21.567 14.2898C18.4308 14.0775 15.9225 11.5692 15.7102 8.43301L13.7148 8.56809ZM11.5 9C12.5155 9 13.4919 9.15898 14.4068 9.45269L15.0182 7.54841C13.9081 7.19204 12.7255 7 11.5 7V9ZM2 18.5C2 13.2533 6.25329 9 11.5 9V7C5.14873 7 0 12.1487 0 18.5H2ZM11.5 28C6.25329 28 2 23.7467 2 18.5H0C0 24.8513 5.14873 30 11.5 30V28ZM21 18.5C21 23.7467 16.7467 28 11.5 28V30C17.8513 30 23 24.8513 23 18.5H21ZM20.5473 15.5931C20.841 16.508 21 17.4845 21 18.5H23C23 17.2745 22.808 16.092 22.4517 14.9819L20.5473 15.5931Z"
        fill={textColor}
        mask="url(#path-1-inside-1)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 15.3552H8.43742C8.18742 15.3552 8.00122 15.0231 8.00122 14.6776C8.00122 14.3305 8.17027 14 8.43742 14H9.1875H14.0625H14.8124C14.9395 14 15.2174 14.308 15.2174 14.6776C15.2174 15.1575 14.8124 15.3552 14.8124 15.3552H14.5V16.5C14.5 17.5625 13.9375 18.5 13 19C13.9375 19.5 14.5 20.4375 14.5 21.5V22.7134H14.8124C15.0624 22.7134 15.2616 23.1066 15.2616 23.3566C15.2616 23.6663 14.9999 23.9998 14.8124 23.9998H14.0148C14.0099 23.9999 14.005 24 14 24H9.1875C9.18253 24 9.17759 23.9999 9.17267 23.9998H8.43744C8.18744 23.9998 7.97729 23.6066 7.97729 23.3566C7.97729 23.1066 8.18744 22.7134 8.43744 22.7134H8.75V21.5C8.75 20.4375 9.3125 19.5 10.25 19C9.3125 18.5 8.75 17.5625 8.75 16.5V15.3552ZM13.3 22.5125V21.1312C13.3 20.4406 12.7017 19.7958 12.0642 19.5302C11.9049 19.5302 11.8517 19.3708 11.8517 19.2114V18.7864C11.8517 18.6271 11.9049 18.4677 12.0642 18.4146C12.7017 18.1489 13.3 17.5187 13.3 16.8281V15.5H9.9V16.8812C9.9 17.5719 10.5904 18.2118 11.2279 18.4774C11.3342 18.4774 11.4404 18.6368 11.4404 18.7962V19.2743C11.4404 19.3806 11.3342 19.5399 11.2279 19.5931C10.5904 19.8587 9.9 20.4937 9.9 21.1844V22.5125H13.3Z"
        fill={textColor}
      />
      <text
        id={2}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={8}
        fontWeight={500}
        fill={textColor}
      >
        <tspan x={20 + shiftLeft} y={10.5}>
          {stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(WINGDeliveryStopMarker);
